import { List } from "../transactions/nfoAndNewPurchase";
import Signbutton from "../../forms/button";
import { Input } from "../../forms/input";
import IntegrationReactSelect from "../../forms/autoCompleteInput";
import CustomizedDialogs from "../customModal";
import CustomLoader from "../../forms/Loader";

import React, { useEffect, useReducer, useRef } from "react";
import {
  ALL,
  GET_FUNDS_LIST,
  GET_FUNDS_LIST_FAILED,
  GET_FUNDS_LIST_SUCCESS,
} from "../../../store/types";
import { connect } from "react-redux";
import { getNewPurchaseFundList } from "../../../store/actions";
import { getCapitalGainLoss } from "../../../store/actions/mailback";

import getFiscalYear from "../../forms/getFiscalYear";

import Paper from "@material-ui/core/Paper";
import DateFnsUtils from "@date-io/date-fns";
import "react-datepicker/dist/react-datepicker.css";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  ListItemText,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  ListItemIcon,
} from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

const CCGS = (props) => {
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const confirmPasswordRef = useRef(null);
  const panRef = useRef(null);
  const amcRef = useRef(null);
  const [fs] = getFiscalYear(0);
  const initialState = {
    email: { value: "" },
    pan: { value: props.investorData.PAN || "" },
    password: { value: "" },
    confirmPassword: { value: "" },
    format: { value: "PDF" },
    delivery: { value: "Email a download link" },
    period: { value: { label: "Current Fiscal Year", value: "current" } },
    fromDate: {
      value: fs,
    },
    toDate: { value: new Intl.DateTimeFormat("en-US").format(new Date()) },
    modal: false,
    loading: false,
    amcList: [],
    selectedNames: [],
    selectedValues: [],
    amcErrorMessage: false,
  };

  const [formValues, setFormValues] = useReducer(
    (preValues, newValues) => ({ ...preValues, ...newValues }),
    initialState
  );

  useEffect(() => {
    setFormValues({ loading: true });
    const params = {
      opt: ALL,
    };
    const types = [
      GET_FUNDS_LIST,
      GET_FUNDS_LIST_SUCCESS,
      GET_FUNDS_LIST_FAILED,
    ];
    const getAmcList = async () => {
      const response = await props.getNewPurchaseFundList(params, types);
      const { Dtinformation } = response;
      setFormValues({
        amcList: Dtinformation,
      });
    };
    getAmcList();
    setFormValues({ loading: false });
  }, []);

  const periodOptions = [
    { label: "Current Fiscal Year", value: 0 },
    { label: "Previous Fiscal Year", value: -1 },
    { label: "2nd Last Fiscal Year", value: -2 },
    { label: "3rd Last Fiscal Year", value: -3 },
  ];

  const handleChange = (label) => (event) => {
    const value = event.target.value;
    switch (label) {
      //"^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$" Regex for password
      //^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$   Email Regex
      case "email":
        if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(value)) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              isShowError: true,
              errorMessage: "Enter a valid Email ID",
            },
          });
        } else {
          setFormValues({
            [label]: { value },
          });
        }
        break;
      case "password":
        if (
          !/^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&:;.,/])[A-Za-z\d@$!%*?&]{8,}$/.test(
            value
          )
        ) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              isShowError: true,
              errorMessage:
                "A Valid Password must have minimum 8 characters with atleast one capital letter, one number and one symbol",
            },
          });
        } else {
          setFormValues({
            [label]: {
              value,
              isError: false,
              isShowError: false,
            },
          });
        }
        break;
      case "confirmPassword":
        if (password.value !== value) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              isShowError: true,
              errorMessage: "Please enter the same password as above",
            },
          });
        } else {
          setFormValues({
            [label]: {
              value,
              isError: false,
              isShowError: false,
            },
          });
        }
        break;
      default:
        setFormValues({
          [label]: {
            value,
            isError: false,
            isShowError: false,
          },
        });
        break;
    }
  };
  const validate = (label) => (event) => {
    const value = event.target.value;
    switch (label) {
      case "password":
        if (
          !!value &&
          !/^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
            value
          )
        ) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              isShowError: true,
              errorMessage:
                "A Valid Password must have minimum 8 characters with atleast one capital letter, one number and one symbol",
            },
          });
        } else if (!value) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              isShowError: true,
              errorMessage: "Password is Mandatory*",
            },
          });
        }
        break;
      case "confirmPassword":
        if (!value) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              isShowError: true,
              errorMessage: "Confirmation Password is Mandatory*",
            },
          });
        } else if (value !== password.value) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              isShowError: true,
              errorMessage: "Please enter the same password as above",
            },
          });
        }
        break;
      case "pan":
        if (!!value && !/[A-Za-z]{5}\d{4}[A-Za-z]{1}/.test(value)) {
          setFormValues({
            pan: {
              value,
              isError: true,
              isShowError: true,
              errorMessage: "Enter a Valid PAN Number",
            },
          });
        } else if (!value) {
          setFormValues({
            pan: {
              value,
              isError: true,
              isShowError: true,
              errorMessage: "PAN is Mandatory*",
            },
          });
        }
        break;
      case "email":
        if (
          !!value &&
          !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(value)
        ) {
          setFormValues({
            email: {
              value,
              isError: true,
              isShowError: true,
              errorMessage: "Enter a valid Email ID",
            },
          });
        } else if (!value) {
          setFormValues({
            email: {
              value,
              isError: true,
              isShowError: true,
              errorMessage: "Email Id is Mandatory*",
            },
          });
        }
        break;
      default:
        break;
    }
  };
  const handlePeriodChange = (value) => {
    const Period = value;
    const PeriodValue = Period.value;
    const [fs, fe] = getFiscalYear(PeriodValue);
    switch (PeriodValue) {
      case 0:
        setFormValues({
          period: { value: Period },
          fromDate: initialState.fromDate,
          toDate: initialState.toDate,
        });
        break;
      case -1:
        setFormValues({
          period: { value: Period },
          fromDate: { value: fs },
          toDate: { value: fe },
        });

        break;
      case -2:
        setFormValues({
          period: { value: Period },
          fromDate: { value: fs },
          toDate: { value: fe },
        });
        break;
      case -3:
        setFormValues({
          period: { value: Period },
          fromDate: { value: fs },
          toDate: { value: fe },
        });
        break;
      default:
        break;
    }
  };
  const handleAmcChange = (event) => {
    const { selectedNames, amcList } = formValues;
    const amcNames = amcList.map((e) => e.amc_name);
    const name = event.target.value;
    if (name[name.length - 1] === "all") {
      setFormValues({
        selectedNames: selectedNames.length === amcList.length ? [] : amcNames,
      });
      return;
    }
    if (!selectedNames.includes(name)) {
      setFormValues({
        selectedNames: name,
        amcErrorMessage: false,
      });
    }
  };

  const submit = async () => {
    const {
      format,
      delivery,
      period,
      fromDate,
      toDate,
      modal,
      loading,
      amcList,
      selectedValues,
      selectedNames,
      amcErrorMessage,
      ...others
    } = formValues;
    const keys = Object.keys(others);
    const isFoundError = keys.every((key) => !!others[key].value);
    const firstErroredKey = keys.find((key) => !others[key].value);
    if (!isFoundError) {
      keys.forEach((key) => {
        if (!others[key].value) {
          setFormValues({
            [key]: {
              value: "",
              isError: true,
              isShowError: true,
              errorMessage:
                key === "email"
                  ? "Email Id is Mandatory*"
                  : key === "pan"
                  ? "PAN is Mandatory*"
                  : key === "password"
                  ? "Password is Mandatory*"
                  : key === "confirmPassword"
                  ? "Confirmation Password is Mandatory*"
                  : "",
            },
          });
        }
      });
      switch (firstErroredKey) {
        case "email":
          emailRef.current.focus();
          break;
        case "pan":
          panRef.current.focus();
          break;
        case "password":
          passwordRef.current.focus();
          break;
        case "confirmPassword":
          confirmPasswordRef.current.focus();
          break;
        default:
          break;
      }
      return;
    } else if (selectedNames.length === 0) {
      setFormValues({
        amcErrorMessage: true,
      });
      amcRef.current.focus();
      return;
    } else if (
      !/^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
        formValues.password.value
      )
    ) {
      setFormValues({
        password: {
          value: formValues.password.value,
          isError: true,
          isShowError: true,
          errorMessage:
            "A Valid Password must have minimum 8 characters with atleast one capital letter, one number and one symbol",
        },
      });
      passwordRef.current.focus();
      return;
    } else if (!/[A-Za-z]{5}\d{4}[A-Za-z]{1}/.test(formValues.pan.value)) {
      setFormValues({
        pan: {
          value: formValues.pan.value,
          isError: true,
          isShowError: true,
          errorMessage: "Enter a Valid PAN Number",
        },
      });
      panRef.current.focus();
      return;
    } else if (
      !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
        formValues.email.value
      )
    ) {
      setFormValues({
        email: {
          value: formValues.email.value,
          isError: true,
          isShowError: true,
          errorMessage: "Enter a valid Email ID",
        },
      });
      emailRef.current.focus();
      return;
    } else if (formValues.password.value !== formValues.confirmPassword.value) {
      setFormValues({
        [confirmPassword]: {
          value: "",
          isError: true,
          isShowError: true,
          errorMessage: "Please enter the same password as above",
        },
      });
      confirmPasswordRef.current.focus();
      return;
    } else {
      setFormValues({ loading: true });
      const funds = selectedNames.map((amc_name) =>
        amcList.find((e) => e.amc_name === amc_name)
      );
      const fundValues = funds.map((fund) =>
        parseInt(fund.amc_code) == fund.amc_code
          ? parseInt(fund.amc_code)
          : "RMF"
      );

      const params = {
        PAN: pan.value,
        Email: email.value,
        Password: password.value,
        CnmPassword: confirmPassword.value,
        Fromdate: fromDate.value,
        Todate: toDate.value,
        EmailDownload: delivery.value,
        Fund: fundValues.join(",").replace('"', ""),
        AccountStFormat: format.value,
      };
      await props.getCapitalGainLoss(params);
      setFormValues({ loading: false, modal: true });
    }
  };

  const {
    email,
    format,
    password,
    pan,
    confirmPassword,
    delivery,
    period,
    fromDate,
    toDate,
    modal,
    loading,
    amcList,
    selectedNames,
    amcErrorMessage,
  } = formValues;
  const isAllSelected =
    amcList.length > 0 && selectedNames.length === amcList.length;
  return (
    <>
      <Paper
        className="digital-form-container"
        style={{
          boxShadow: "0px 0px 2px 0px lightgray",
          marginTop: 20,
          margin: "20px 30px 20px",
        }}
      >
        <CustomLoader display={loading} />
        <CustomizedDialogs
          open={modal}
          componentName="ccgs"
          closeModal={() => props.history.push(`/mailBackRequest/investor`)}
        />
        <div className="digital-form-left-div">
          <List investorData={props.investorData} />
        </div>
        <div className="digital-form-Right-div">
          <div className="transaction-details">
            <div className="title">Capital Gains Account Statement</div>
          </div>
          <div className="input-margin">
            <Input
              name="PAN Number"
              value={pan.value}
              disabled={!!props.investorData.PAN}
              onChange={handleChange("pan")}
              onBlur={validate("pan")}
              isError={pan.isError}
              errorMessage={pan.errorMessage}
              inputref={panRef}
            />
          </div>
          <div className="input-margin">
            <Input
              name="Email ID"
              value={email.value}
              onChange={handleChange("email")}
              onBlur={validate("email")}
              isError={email.isError}
              isShowError={email.isError}
              errorMessage={email.errorMessage}
              inputref={emailRef}
            />
          </div>
          <div className="input-margin">
            <br />
            <div className="appbar-div" style={{ marginTop: -15 }}>
              <div className="state-responsive input-responsive">Period*</div>
              <IntegrationReactSelect
                suggestions={periodOptions.map((item) => ({
                  label: item.label,
                  value: item.value,
                }))}
                value={period.value}
                label="Period*"
                errorMessage={period.errorMessage}
                handleChange={handlePeriodChange}
              />
            </div>
          </div>
          <div style={{ width: "100%" }}>
            <div className="input-name ">Start Date</div>
            <MuiPickersUtilsProvider
              utils={DateFnsUtils}
              style={{ width: "100%" }}
            >
              <KeyboardDatePicker
                required={true}
                className="selects"
                disableFuture={true}
                format="dd/MM/yyyy"
                value={fromDate.value}
                disabled
                style={{ marginTop: 0, marginBottom: 10 }}
                margin="normal"
                id="mui-pickers-date"
              />
            </MuiPickersUtilsProvider>

            <div className="input-margin">
              <div className="input-field-container input-name">End Date</div>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  required={true}
                  className="selects"
                  disableFuture={true}
                  disabled={true}
                  format="dd/MM/yyyy"
                  id="mui-pickers-date"
                  value={toDate.value}
                />
              </MuiPickersUtilsProvider>
            </div>
          </div>
          <div className="selects" style={{ marginTop: 20 }}>
            <div className="input-name">AMC</div>

            <Select
              multiple
              fullWidth={true}
              value={selectedNames}
              onChange={handleAmcChange}
              renderValue={(selected) =>
                selected.length < 3 ? selected.join(", ") : "Multiple"
              }
              style={{
                border: amcErrorMessage ? "1px solid red" : "1px solid #a6a6a6",
                borderTop: amcErrorMessage
                  ? "2px solid red"
                  : "2px solid #a6a6a6",
                borderRadius: 7,
              }}
              ref={amcRef}
            >
              <MenuItem value="all">
                <ListItemIcon>
                  <Checkbox
                    checked={isAllSelected}
                    indeterminate={
                      selectedNames.length > 0 &&
                      selectedNames.length < amcList.length
                    }
                  />
                </ListItemIcon>
                <ListItemText primary="Select All" />
              </MenuItem>
              {amcList.map((amc) => (
                <MenuItem key={amc.amc_name} value={amc.amc_name}>
                  <ListItemIcon>
                    <Checkbox
                      checked={selectedNames.indexOf(amc.amc_name) > -1}
                    />
                  </ListItemIcon>
                  <ListItemText primary={amc.amc_name} />
                </MenuItem>
              ))}
            </Select>

            {amcErrorMessage && (
              <div style={{ color: "red", fontFamily: "OpenSans-Italic" }}>
                Please Select atleast one Mutual Fund to Continue
              </div>
            )}
          </div>
          <div className="input-margin">
            <Input name="Delivery Option" value={delivery.value} disabled />
          </div>
          <div className="input-margin">
            <div className="input-name">Statement Format</div>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="Search"
                name="search"
                style={{ flexDirection: "row" }}
                value={format.value}
                onChange={handleChange("format")}
              >
                <div className="investor-radio-button">
                  <FormControlLabel
                    value="PDF"
                    control={
                      <Radio
                        className="investor-search-radio"
                        style={{ color: "#007ac8" }}
                      />
                    }
                    className="investor-formcontrol-label"
                    style={{ margin: 0 }}
                  />
                  <div className="investor-form-label">PDF</div>
                </div>
                <div className="investor-radio-button">
                  <FormControlLabel
                    value="EXCEL"
                    control={
                      <Radio
                        className="investor-search-radio"
                        style={{ color: "#007ac8" }}
                      />
                    }
                    className="investor-formcontrol-label"
                    style={{ margin: 0 }}
                  />
                  <div className="investor-form-label">EXCEL</div>
                </div>
              </RadioGroup>
            </FormControl>
          </div>
          <div className="input-margin">
            <Input
              name="Password"
              type="password"
              value={password.value}
              onChange={handleChange("password")}
              isError={password.isError}
              isShowError={password.isError}
              errorMessage={password.errorMessage}
              onBlur={validate("password")}
              inputref={passwordRef}
            />
          </div>
          <div className="input-margin">
            <Input
              name="Confirm Password"
              type="password"
              value={confirmPassword.value}
              onChange={handleChange("confirmPassword")}
              isError={confirmPassword.isError}
              isShowError={confirmPassword.isError}
              errorMessage={confirmPassword.errorMessage}
              onBlur={validate("confirmPassword")}
              inputref={confirmPasswordRef}
            />
          </div>
          <div className="digital-form-button-next-div">
            <Signbutton buttontitle="Submit" onClick={submit} />
          </div>
        </div>
      </Paper>
    </>
  );
};

export default connect(
  ({ authReducer, transactions }) => {
    const { investorData, userId, token } = authReducer;
    const { fundsList } = transactions;
    return { investorData, userId, token, fundsList };
  },
  { getNewPurchaseFundList, getCapitalGainLoss }
)(CCGS);
